import React from "react";
import { cn } from "../utils/cn";
import { SemoMotionLoader } from "./semo-motion/SemoMotionLoader";

export interface LogoLoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Height of the loader in pixels.
   * @default "md"
   */
  size?: "sm" | "md" | "lg" | "xl" | number;

  /**
   * Custom loading text to display below the logo.
   */
  text?: string;

  /**
   * Whether to show the default text "Loading..." if no custom text is provided.
   * @default false
   */
  showText?: boolean;

  /**
   * @deprecated 로고를 튀기거나 돌리던 옛 방식. 지금은 모두 세모 로고 로딩 모션 하나로 그린다.
   */
  variant?: "pulse" | "spin" | "bounce" | "ping" | "none";
}

const sizeMap = {
  sm: 32,
  md: 64,
  lg: 112,
  xl: 160,
};

export function LogoLoader({
  className,
  size = "md",
  text,
  showText = false,
  variant: _variant,
  ...props
}: LogoLoaderProps) {
  const height = typeof size === "number" ? size : sizeMap[size];
  const displayText = text ?? (showText ? "잠시만 기다려주세요..." : null);

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3",
        className,
      )}
      {...props}
    >
      <SemoMotionLoader size={height} />

      {displayText && (
        <p className="text-muted-foreground text-sm font-medium text-center">
          {displayText}
        </p>
      )}
    </div>
  );
}
